import React, { useEffect, useState, useRef } from "react";
import Pagination from "react-bootstrap/Pagination";
import Share from "./Share";

function BlogListDummy({ api, json }) {
  const ref = useRef(null);
  const [allBlogs, setAllBlogs] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [limit, setLimit] = useState(6);
  const [activePage, setActivePage] = useState(1);
  // Get useDashboardAPI from query string
  const getUseDashboardAPI = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("useDashboardAPI") === "true";
  };

  const getLimit = () =>
    window.matchMedia("(max-width: 768px)").matches ? 3 : 6;

  const paginate = (data, page, limit) => {
    const offset = (page - 1) * limit;
    return data.slice(offset, offset + limit);
  };

  const fetchDataOld = async () => {
    try {
      const [jsonRes, apiRes] = await Promise.all([
        fetch(`${json}?r=${Date.now()}`).then((res) => res.json()),
        fetch(`${api}?r=${Date.now()}`).then((res) => res.json()),
      ]);

      let apiArr = [];
      if (apiRes && apiRes.status === "ok" && Array.isArray(apiRes.results)) {
        apiArr = apiRes.results;
      }

      const merged = [...apiArr, ...jsonRes];
      const initialLimit = getLimit();

      setAllBlogs(merged);
      setLimit(initialLimit);
      setDisplayData(paginate(merged, 1, initialLimit));
    } catch (err) {
      console.error("Error fetching blog data", err);
    }
  };

  // Fetches blog data from the provided JSON and, if enabled, from the API as well.
  // Merges the results, sets the initial pagination limit based on screen size, and updates state.
  // Uses the "useDashboardAPI" query parameter to determine if API data should be fetched.
  const fetchData = async () => {
    const useDashboardAPI = getUseDashboardAPI();
    try {
      // Always fetch JSON
      const jsonPromise = fetch(`${json}?r=${Date.now()}`).then((res) =>
        res.json()
      );

      let apiPromise = Promise.resolve([]);
      if (useDashboardAPI) {
        apiPromise = fetch(`${api}?r=${Date.now()}`)
          .then((res) => res.json())
          .then((apiRes) => {
            if (
              apiRes &&
              apiRes.status === "ok" &&
              Array.isArray(apiRes.results)
            ) {
              return apiRes.results;
            }
            return [];
          });
      }

      const [jsonRes, apiArr] = await Promise.all([jsonPromise, apiPromise]);

      const merged = [...apiArr, ...jsonRes];
      const initialLimit = getLimit();

      setAllBlogs(merged);
      setLimit(initialLimit);
      setDisplayData(paginate(merged, 1, initialLimit));
    } catch (err) {
      console.error("Error fetching blog data", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const newLimit = getLimit();
      setLimit(newLimit);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setDisplayData(paginate(allBlogs, activePage, limit));
  }, [limit, activePage, allBlogs]);

  const handlePageChange = (page) => {
    setActivePage(page);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getPageLink = (item) => item.link || `./blogs/${item.id}`;

  const renderReadingTime = (item) => {
    var reading_time = item.reading_time;
    //var reading_time = rt;
    //`<p class="read-time"0>Reading Time: ${item.reading_time} min</p>`

    if (reading_time.indexOf("<p") == -1) {
      reading_time = `<p class="read-time"0>Reading Time: ${item.reading_time} min</p>`;
    }
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: reading_time,
        }}
      />
    );
  };

  const renderDate = (item) => {
    let date = "";
    if (item.date) {
      date = item.date;
    } else if (item.date_published) {
      date = formatDate(item.date_published);
    }
    return <span className="date">{date}</span>;
  };

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <section className="container blog-posts" ref={ref}>
      <div className="row mt-2">
        {displayData.map((item, index) => {
          const articleContent = (
            <>
              <div className="blog-post-header">
                <h2>{item.title}</h2>
                <div className="blog-post-meta">
                  <img src="./assets/images/ico-calendar.png" alt="calendar" />
                  {renderDate(item)}
                </div>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: item.short_description,
                }}
              />
              {item.reading_time && (
                <div className="d-flex justify-content-start flex-wrap">
                  <p>
                    <img
                      style={{ width: "1em", marginBottom: "1em" }}
                      src="./assets/images/ico-timer.svg"
                      alt="timer"
                    />
                  </p>
                  &nbsp;&nbsp;
                  <div>{renderReadingTime(item)}</div>
                  {/* <div
                    dangerouslySetInnerHTML={{
                      __html: item.reading_time,
                    }}
                    
                  /> */}
                </div>
              )}
              <a
                href={getPageLink(item)}
                target={item.link ? "_blank" : "_self"}
                className="btn btn-primary read-more-btn gtm-lp gtm-blog-read-more"
              >
                READ MORE
              </a>
              {/* &nbsp;&nbsp;
              <div className="share-container blog-list">
                <Share
                  url={`./blogs/${item.id}`}
                  msg={"Watch%20Now%20On%20Fawesome"}
                ></Share>
              </div> */}
            </>
          );

          return (
            <article className="blog-post" key={index}>
              <div className="blog-post-container row">
                {index % 2 === 0 ? (
                  <>
                    <div className="blog-post-image col-md-4 col-sm-12">
                      <img src={item.image} alt={item.alt_text} />
                    </div>
                    <div className="blog-post-content col-md-8 col-sm-12">
                      {articleContent}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="blog-post-content col-md-8 col-sm-12">
                      {articleContent}
                    </div>
                    <div className="blog-post-image col-md-4 col-sm-12">
                      <img src={item.image} alt={item.alt_text} />
                    </div>
                  </>
                )}
              </div>
            </article>
          );
        })}
      </div>

      {allBlogs.length > limit && (
        <Pagination className="px-4 d-flex justify-content-center flex-wrap">
          <Pagination.Prev
            disabled={activePage === 1}
            onClick={() => handlePageChange(activePage - 1)}
          />
          {Array.from({ length: Math.ceil(allBlogs.length / limit) }).map(
            (_, index) => (
              <Pagination.Item
                key={index}
                active={index + 1 === activePage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            )
          )}
          <Pagination.Next
            disabled={activePage === Math.ceil(allBlogs.length / limit)}
            onClick={() => handlePageChange(activePage + 1)}
          />
        </Pagination>
      )}
    </section>
  );
}

export default BlogListDummy;
